import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function FinalCTASection() {
  return <section className="py-24 bg-[#2D1B4E] text-white relative overflow-hidden" data-id="element-71">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#D4A574] opacity-10 blur-[120px] rounded-full pointer-events-none" data-id="element-72" />

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-73">
        <div className="max-w-3xl mx-auto text-center" data-id="element-74">
          <FadeIn data-id="element-75">
            <h2 className="text-3xl md:text-5xl font-bold mb-8 leading-tight" data-id="element-76">
              You don't need another label. <br data-id="element-77" />
              <span className="text-[#D4A574] italic" data-id="element-78">
                You need to come home to yourself.
              </span>
            </h2>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-79">
            <p className="text-xl text-[#E8D5D5] mb-10" data-id="element-80">
              You've done the insight work. Now it's time for integration.
            </p>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-81">
            <div className="flex flex-col items-center gap-4" data-id="element-82">
              <Button size="lg" className="w-full sm:w-auto text-lg px-12 py-4" withIcon href="https://www.dreambuk.com/cart/45563104067770:1" data-id="element-83">
                Get Instant Access – $6.36
              </Button>
              <p className="text-sm text-gray-400" data-id="element-84">
                Secure payment • Instant download • 100% Money-back guarantee
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}